import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 44 35",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 35\" id=\"icon-check\"><path fill=\"#fff\" d=\"M4.536 17.218L.364 21.39l13.41 13.41L43.574 5 39.4.83 13.774 26.456z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol